import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import ShiftEntry from "@/pages/ShiftEntry";
import Config from "@/pages/Config";
import Reports from "@/pages/Reports";
import Banking from "@/pages/Banking";
import Accounting from "@/pages/Accounting";
import Store from "@/pages/Store";
import { Loader2 } from "lucide-react";
import { isAccountant } from "@/lib/roles";
import Layout2 from "@/v2/Layout2";
import Dashboard2 from "@/v2/Dashboard2";
import Shifts2 from "@/v2/Shifts2";
import Shift2 from "@/v2/Shift2";

function Protected({ children, accountantOnly, v2 }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (accountantOnly && !isAccountant(user)) return <Navigate to="/" replace />;
  return v2 ? <Layout2>{children}</Layout2> : <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user && user !== false) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/shift/:id" element={<Protected><ShiftEntry /></Protected>} />
            <Route path="/config" element={<Protected><Config /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/banking" element={<Protected><Banking /></Protected>} />
            <Route path="/store" element={<Protected><Store /></Protected>} />
            <Route path="/accounting" element={<Protected><Accounting /></Protected>} />
            <Route path="/v2" element={<Protected v2><Dashboard2 /></Protected>} />
            <Route path="/v2/shifts" element={<Protected v2><Shifts2 /></Protected>} />
            <Route path="/v2/shift/:id" element={<Protected v2><Shift2 /></Protected>} />
            <Route path="/v2/shift/:id/:view" element={<Protected v2><Shift2 /></Protected>} />
            <Route path="/v2/shift/:id/:view/:sub" element={<Protected v2><Shift2 /></Protected>} />
            <Route path="/v2/*" element={<Navigate to="/v2" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
